<template>
  <el-container>
    <el-header class="table-header">
      <el-button icon="el-icon-refresh" type="primary" @click="refreshData()" size="small">{{$t('common.Refresh')}}</el-button>
      <el-button icon="el-icon-search" @click="search('refresh')" size="small">{{$t('common.Search')}}</el-button>
      <el-button icon="el-icon-refresh-left" @click="form = {}" size="small">{{$t('common.Reset')}}</el-button>
    </el-header>
    <el-container>
      <el-main class="table-main">
        <el-form :model="form" label-width="90px" size="mini" class="table-form">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.info.url.CenterName')" prop="centerName">
                <el-input v-model="form.centerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.url.ServiceName')" prop="serviceName">
                <el-input v-model="form.serviceName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.url.ModuleName')" prop="moduleName">
                <el-input v-model="form.moduleName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('base.info.url.TypeName')" prop="className">
                <el-input v-model="form.className"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table :data="tableData" border stripe style="width: 100%">
          <el-table-column type="index">
          </el-table-column>
          <el-table-column prop="accessMethod" :label="$t('base.info.url.AccessMethod')" align="center" width="100%">
          </el-table-column>
          <el-table-column prop="accessUrl" :label="$t('base.info.url.AccessAddress')" align="left" width="380%">
          </el-table-column>
          <el-table-column prop="centerName" :label="$t('base.info.url.CenterName')" align="left" width="100%">
          </el-table-column>
          <el-table-column prop="serviceName" :label="$t('base.info.url.ServiceName')" align="left" width="100%">
          </el-table-column>
          <el-table-column prop="moduleName" :label="$t('base.info.url.ModuleName')" align="left" width="100%">
          </el-table-column>
          <el-table-column prop="classMethod" :label="$t('base.info.url.TypeMethod')" width="220%" align="left">
          </el-table-column>
          <el-table-column prop="className" :label="$t('base.info.url.TypeName')" align="left" width="400%">
          </el-table-column>
          <el-table-column prop="functName" :label="$t('base.info.url.FunctName')" align="left" width="100%">
          </el-table-column>
          <el-table-column prop="matchPath" :label="$t('base.info.url.MatchPath')" width="220%" align="left">
          </el-table-column>
          <el-table-column prop="menuName" :label="$t('base.info.url.MenuName')" align="left">
          </el-table-column>

          <el-table-column prop="createTime" :label="$t('common.CreateTime')" width="120%" align="right" :formatter="changeTime">
          </el-table-column>
          <el-table-column fixed="right" width="80%" align="center" :label="$t('common.Operate')">
            <template slot-scope="scope">
              <router-link :to="{name: 'urlEdit', params: {row:scope.row}}">
                <el-button size="mini" type="text">{{$t('common.Edit')}}</el-button>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <el-footer class="table-footer">
          <table-page ref="menuUrlListPage" :url="menuUrlList" :form="form" @page-change="convert"></table-page>
        </el-footer>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import TablePage from '@/components/TablePage'
import moment from 'moment'

export default {
  data () {
    return {
      form: {},
      tableData: [],
      menuUrlList: this.global.BASE_ACL + '/url/findAllUrl'
    }
  },
  components: {
    TablePage
  },
  methods: {
    changeTime (row, column) {
      let date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD')
    },
    search (param) {
      this.$refs['menuUrlListPage'].getTableData(param)
    },
    refreshData () {
      this.$api.urlList.urlRefresh().then((response) => {
        if (response.data.status === 'Y') {
          this.$message({
            message: response.data.message,
            type: 'success'
          })
        } else {
          this.$message({
            message: response.data.message,
            type: 'error'
          })
        }
      })
    },
    convert (table) {
      this.tableData = table.data
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/syssetting/UrlList.vue